import { ReactNode } from 'react';
import { View } from 'react-native';
import { styles } from './styles';

type ReadingProps = {
  grid: ReactNode;
  action: ReactNode;
};

const Word = ({ grid, action }: ReadingProps) => {
  return (
    <View style={styles.flex1Row}>
      <View style={styles.flex2}>{grid}</View>
      <View style={styles.flex1MarginRight}>{action}</View>
    </View>
  );
};

const Sentence = ({ grid, action }: ReadingProps) => {
  return (
    <View style={styles.flex1PaddingH}>
      <View style={styles.flex2}>{grid}</View>
      <View style={styles.flex1}>{action}</View>
    </View>
  );
};

export default {
  Word,
  Sentence,
};
